export default {
    unixEpoch: 62135596800,
    feEpoch: 631152000
} as const;
